import Button, { Color, Size } from 'lib/Button';
import { FooterProps } from './Footer.types';

const Footer = ({ onSubmitClick, onCancelClick, isSubmitDisabled = false }: FooterProps): React.ReactElement => {
  return (
    <div className="flex items-center justify-start gap-2">
      <Button
        onClick={onSubmitClick}
        color={Color.PRIMARY}
        isDisabled={isSubmitDisabled}
        size={Size.LARGE}
        label="Submit"
      />

      <Button onClick={onCancelClick} color={Color.SECONDARY} size={Size.LARGE} label="Cancel" />
    </div>
  );
};

export default Footer;
